import { Box, Typography, Chip, Stack } from "@mui/material"
import BarcodeLayout from "./layouts/barcode-layout"
import { LabelLayoutSettingsValues } from "./types"
import { forwardRef } from "react"
import { LotBarcodeT } from "."

interface PrintPreviewProps {
  config: LabelLayoutSettingsValues
  barcodes: LotBarcodeT[]
}

const PrintPreview = forwardRef<HTMLDivElement, PrintPreviewProps>(
  ({ config, barcodes }: PrintPreviewProps, ref: React.Ref<HTMLDivElement>) => {
    const labelSettings = config
    return (
      <>
        {/* Sticky Preview Section */}
        <Box
          sx={{
            position: "sticky",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 10,
            mt: 3,
            // backgroundColor: "#ffffff",
            backgroundColor: (theme) => theme?.palette?.secondary?.light,
            borderRadius: "16px 16px 0 0",
            // border: "1px solid #e9ecef",
            borderBottom: "none",
            boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.1)",
            maxHeight: { xs: "40vh", sm: "50vh" },
            display: "flex",
            flexDirection: "column"
          }}
        >
          {/* Preview Header */}
          <Box
            sx={{
              p: 2,
              // backgroundColor: "#f8f9fa",
              backgroundColor: (theme) => theme?.palette?.background?.paper,
              borderRadius: "16px 16px 0 0",
              // borderBottom: "1px solid #e9ecef",
              position: "sticky",
              top: 0,
              zIndex: 1
            }}
          >
            <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1}>
              <Typography variant="subtitle1" fontWeight="600">
                Print Preview
              </Typography>
              <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                <Chip
                  label={`${labelSettings?.columns ?? 0} Column${(labelSettings?.columns ?? 0 > 1) ? "s" : ""}`}
                  color="primary"
                  variant="outlined"
                  size="small"
                />
                <Chip
                  label={`${barcodes?.length} barcode${barcodes?.length > 1 ? "s" : ""}`}
                  color="default"
                  variant="outlined"
                  size="small"
                />
                <Chip
                  label={barcodes?.[0]?.product?.name || "No product name"}
                  color="default"
                  variant="outlined"
                  size="small"
                  sx={{ maxWidth: { xs: "150px", sm: "200px" }, overflow: "hidden", textOverflow: "ellipsis" }}
                />
              </Stack>
            </Stack>
          </Box>

          {/* Scrollable Preview Content */}
          <Box
            sx={{
              overflowY: "auto",
              overflowX: "hidden",
              p: 2,
              flex: 1
              // "&::-webkit-scrollbar": {
              //   width: "8px"
              // }
              // "&::-webkit-scrollbar-track": {
              //   backgroundColor: "#f1f1f1",
              //   borderRadius: "4px"
              // },
              // "&::-webkit-scrollbar-thumb": {
              //   backgroundColor: "#c1c1c1",
              //   borderRadius: "4px",
              //   "&:hover": {
              //     backgroundColor: "#a8a8a8"
              //   }
              // }
            }}
          >
            <BarcodeLayout
              barcodes={barcodes?.slice(0, config?.columns)}
              config={config}
              //   sx={{ minHeight: "auto" }}
            />
          </Box>
        </Box>
        {/* Summary */}

        {/* ======================================================== */}
        {/* Hidden Printable Component for ReactToPrint */}
        <Box
          sx={{
            display: "none",
            width: "100%",
            margin: "0 !important",
            padding: "0 !important",
            "@media print": {
              display: "block",
              margin: "0 !important",
              padding: "0 !important"
            }
          }}
        >
          <BarcodeLayout barcodes={barcodes} ref={ref} config={config} />
        </Box>
      </>
    )
  }
)

export default PrintPreview
